<template>
    <div>
        <multiselect
            :placeholder="$t('select')"
            v-model="selected"
            :options="options"
            :class="validateError != '' ? 'box-border-color' : ''"
            @input="handleInput($event, multiple)"
            label="text"
            track-by="value"
            :multiple="multiple"
            :close-on-select="!multiple"
            :clear-on-select="!multiple"
            :select-label="''"
            :selected-label="''"
            :deselect-label="''"
            :disabled="disabled"
        >
            <template slot="selection" slot-scope="{ values, search, isOpen }" v-if="multiple">
		        <span class="multiselect__single" v-if="values.length && !isOpen" >
			        {{ translateNSelected(values) }}
		        </span>
            </template>
            <span slot="noOptions">{{ $t('no_options') }}</span>
            <span slot="noResult">{{ $t('no_result_2') }}</span>
        </multiselect>
        <span class="invalid-feedback-custom" v-show="validateError" v-html="validateError"/>
    </div>
</template>

<script>
    // Helpers
    import translateNSelected from '@/helpers/translateNSelected';
    import handleInput from '@/helpers/handleInput';
    import setSelected from '@/helpers/setSelected';

    // Services
    import ParameterService from '@/services/ParameterService';

    // Other
    import qs from 'qs';

    export default {
        props: {
            code: {
                type: String,
            },
            studentType: {
                default: null,
            },
            value: {
                default: null,
            },
            multiple: {
                default: false,
            },
            multipleReturnType: {
                default: 'array',
            },
            multipleShowCount: {
                default: 2,
            },
            validateError: {
                type: String,
                default: '',
            },
            sort: {
                type: String,
                default: 'name',
            },
            filterName: {
                type: String,
                default: null,
            },
            isFilterNameRequired:{
                type: Boolean,
                default:false
            },
            filterOtherUrl: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false
            },
            public: {
                type: Boolean,
                default: false
            },
            withoutItems: {
                type: String,
                default: null
            },
            valueType: {
                default: 'code'
            },
            textType: {
                default: null
            },
            rankPrefix: {
              type: Boolean,
              default: false
            },
            fetch_desired_value:{
                type: Object,
                default: ()=> ({
                    is_active: false,
                    key:'data',
                    value: 'data'
                })
            },
            isCache:{
                type: Boolean,
                default: true
            }
        },
        watch: {
            value: function(newValue) {
                this.selected = this.setSelected(this.value, this.options, this.multiple, this.multipleReturnType);
            },
            filterName: function(newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    this.getOptions()
                }
                else {
                    this.options = []
                }
            },
            withoutItems: function(newValue) {
                this.withoutOptions = newValue.split(',');
                this.getOptions()
            },
        },
        data() {
            return {
                selected: null,
                options: [],
                withoutOptions: [],
            };
        },
        created() {
            if(this.withoutItems){
                this.withoutOptions = this.withoutItems.split(',');
            }
            this.getOptions();
        },
        methods: {
            translateNSelected: translateNSelected,
            setSelected: setSelected,
            handleInput: handleInput,
            getOptions() {
                const key = 'parameter_'+this.code+'_'+(this.public?'public':'not_public')+(this.studentType?('_'+this.studentType):'');

                if(this.isCache){
                  let local = this.getWithExpiry(key);
                  if(local){
                   this.setOptions(local);
                    this.selected = this.setSelected(this.value, this.options, this.multiple, this.multipleReturnType);
                    return;
                  }
                }

                if(!this.public){
                    this.options = [];
                    if(this.filterOtherUrl || this.studentType){
                        if(this.isFilterNameRequired && !this.filterName){
                            return;
                        }

                        const config = {
                            params: {
                                filter: {
                                    parameter_code: this.code,
                                    name: this.filterName,
                                    student_type: this.studentType
                                },
                                sort: this.sort,
                                limit: -1,
                            },
                            paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                        };
                                 ParameterService.getAllItems(config)
                                        .then((response) => {
                                            const data = response.data.data;
                                            this.setWithExpiry(key, data)
                                            this.setOptions(data);
                                        })
                                        .then(() => {
                                            this.selected = this.setSelected(this.value, this.options, this.multiple, this.multipleReturnType);
                                        });
                    }
                    else{
                        const config = {
                            params: {
                                sort: this.sort,
                                student_type: this.studentType,
                            },
                            paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                        };

                        ParameterService.getItems(this.code, config)
                                        .then((response) => {
                                            const data = response.data.data.items;
                                            this.setWithExpiry(key, data)
                                            this.setOptions(data);
                                        })
                                        .then(() => {
                                            this.selected = this.setSelected(this.value, this.options, this.multiple, this.multipleReturnType);
                                        });
                    }
                }
                else {
                    this.options = [];

                    const config = {
                        params: {
                            parameter_code: this.code,
                            student_type: this.studentType,
                            limit: -1,
                        },
                        paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                    };

                    ParameterService.getItemsPublic(config)
                                    .then((response) => {
                                        const data = response.data.data;
                                        this.setWithExpiry(key, data)
                                        this.setOptions(data);
                                    })
                                    .then(() => {
                                        this.selected = this.setSelected(this.value, this.options, this.multiple, this.multipleReturnType);
                                    })
                }
            },
            setOptions(data){
                if (data) {
                    data.map((item) => {
                        if(!this.withoutOptions.includes(item.code)) {
                          let text = this.textType ? item[this.textType] : item.name;
                          if(this.rankPrefix){
                            text = item.rank + '. ' + text;
                          }
                          if (this.fetch_desired_value.is_active){
                            this.options.push({
                              value: item[this.valueType],
                              text: text,
                              data: item.data,
                              [this.fetch_desired_value.key]:item[this.fetch_desired_value.value]
                            });
                          }else{
                            this.options.push({
                              value: item[this.valueType],
                              text: text,
                              data: item.data
                            });
                          }
                        }
                    })
                }
            },
            getItem(id){
                let found=null
                this.options.forEach((item)=>{
                    if(item.value===id){
                        found = item;
                    }
                });
                return found;
            }
        }
    }
</script>
